import * as z from "zod/v4";

export const getPublicKey = {
  name: "getPublicKey" as const,
  input: z.object({}),
  output: z.object({ publicKey: z.string() }),
};
